import { Base } from '@studiometa/js-toolkit';
import Menu from '../molecules/Menu.js';
import SubMenuHover from '../molecules/SubMenuHover.js';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    components: {
      Menu,
      SubMenuHover,
    },
  };

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.changed For both axis, whether or not the current position has changed since the last one.
   */
  scrolled({ y, changed }) {
    if (!changed.y) {
      return;
    }

    if (y > 100) {
      this.$el.classList.add('header--down');
    }

    if (y === 0) {
      this.$el.classList.remove('header--down');
    }
  }

  /**
   * mouseenter
   */
  onMenuEnter() {
    if (window.scrollY === 0) {
      this.$el.classList.add('header--down');
    }
  }

  /**
   * mouseleave
   */
  onMenuLeave() {
    if (window.scrollY === 0) {
      this.$el.classList.remove('header--down');
    }
  }
}
